__turbopack_context__.v({
  "className": "nunito_sans_979100fa-module__Dp44kq__className",
  "variable": "nunito_sans_979100fa-module__Dp44kq__variable",
});
